/**
 * Social Share - Simple social media sharing without external libraries
 * Supports: Facebook, Twitter/X, LinkedIn, WhatsApp, Email
 */

const SocialShare = {
    // Configuration for popup window dimensions
    config: {
        width: 550,
        height: 420
    },

    /**
     * Open a centered popup window
     * @param {string} url - The URL to open
     */
    openPopup: function(url) {
        const left = (screen.width / 2) - (this.config.width / 2);
        const top = (screen.height / 2) - (this.config.height / 2);
        const features = `width=${this.config.width},height=${this.config.height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`;

        window.open(url, 'share', features);
    },

    /**
     * Share on Facebook
     * @param {string} url - URL to share
     */
    facebook: function(url) {
        const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        this.openPopup(fbUrl);
    },

    /**
     * Share on Twitter/X
     * @param {string} url - URL to share
     * @param {string} text - Tweet text
     */
    twitter: function(url, text) {
        const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
        this.openPopup(twitterUrl);
    },

    /**
     * Share on LinkedIn
     * @param {string} url - URL to share
     * @param {string} title - Article title
     */
    linkedin: function(url, title) {
        const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
        this.openPopup(linkedinUrl);
    },

    /**
     * Share on WhatsApp
     * @param {string} url - URL to share
     * @param {string} text - Message text
     */
    whatsapp: function(url, text) {
        const message = `${text} ${url}`;
        const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
        // WhatsApp opens in new tab instead of popup
        window.open(whatsappUrl, '_blank');
    },

    /**
     * Share via Email
     * @param {string} url - URL to share
     * @param {string} subject - Email subject
     */
    email: function(url, subject) {
        const body = `Je pensais que cet article pourrait t'intéresser :\n\n${url}`;
        const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoUrl;
    }
};

// Initialize event listeners when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Add click handlers to all share buttons
    document.querySelectorAll('[data-share]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();

            const platform = this.dataset.share;
            const url = this.dataset.url || window.location.href;
            const text = this.dataset.text || document.title;
            const title = this.dataset.title || document.title;
            const subject = this.dataset.subject || document.title;

            // Call the appropriate sharing method
            switch(platform) {
                case 'facebook':
                    SocialShare.facebook(url);
                    break;
                case 'twitter':
                    SocialShare.twitter(url, text);
                    break;
                case 'linkedin':
                    SocialShare.linkedin(url, title);
                    break;
                case 'whatsapp':
                    SocialShare.whatsapp(url, text);
                    break;
                case 'email':
                    SocialShare.email(url, subject);
                    break;
                default:
                    console.warn(`Unknown share platform: ${platform}`);
            }
        });
    });
});
